import React, { useState, useEffect } from 'react';
import { getLabel } from '../../../InitData';
import Jersey from '../../../data/jerseys/Jersey';
import Img from '../../../common/util/Img';
import { AgendaStreamingContext } from '../../../common/AgendaStreamingContextProvider';
import { WidgetContext } from '../../../data/widgets/WidgetContext';
import { iconCategoryCssClass, iconSportCssClass } from '../../../data/utils';
import { getMatchStreamingProps, getStreamingId } from '../../../data/streaming/streamingUtils';
import MainContext from '../../../contexts/MainContext';
import PrematchContext from '../../../contexts/PrematchContext';


function AgendaStreamingSport(props) {
    const mainContext = React.useContext(MainContext);
    const widgetContext = React.useContext(WidgetContext);
    const agendaStreamingContext = React.useContext(AgendaStreamingContext);
    const prematchContext = React.useContext(PrematchContext);
    const [toggled, setToggled] = useState(true);

    useEffect(function() {
        return () =>{
            mainContext.toggleStreaming(null,null,null);
            widgetContext.setWidget({
                isWidgetToggleable: true
            });
        }
    },[]);

    function toggleStreaming(match){
        const streamingProps = getMatchStreamingProps(match);
        const streamingId = streamingProps && getStreamingId(streamingProps[match.id]);
        const streamingInfo = streamingProps && streamingProps[match.id];
        closeWidgetMatch();
        mainContext.toggleStreaming(streamingInfo,streamingId,match.id,'betslip');
    }

    function closeWidgetMatch(){
        widgetContext.setWidget({
            widgetMatchId: null
        });
    }


    const firstTournament = props.tournamentsById && Object.values(props.tournamentsById)[0];
    const icoSport = firstTournament && iconSportCssClass(firstTournament.sportRef,firstTournament.iconClassSport);
    
    return (
        <>
            <div className="bg-nero bianco titolo-blocco-sport pointer" onClick={() => setToggled(!toggled)}>
                <span className="d-centro-v maiuscolo">
                        <div className={`img-fluid icona-sport margine-dx-mezzo ico-sport ${icoSport}`}></div>
                        {props.sportDesc}
                </span>
            </div>
            {
                <>
                    {Object.values(props.tournamentsById).map((tournament, tIndex) => {
                        const icoCategory = iconCategoryCssClass(tournament.sportRef, tournament.categoryRef, tournament.iconClassCountry)
                        return ( tournament.hasMatches && 
                            <div key={tIndex} className="contenitore-table bg-bianco">
                                <div className={"titolo-competizione-live bg-grigio-scuro pointer bianco bordo-tondo margine-giu-mezzo toggle-nascondi-live "+(props.collapse?'collapsed':'')} data-toggle="collapse" data-target={"#tournament-collapse-" + tournament.tournamentId}>
                                    <div className={`img-fluid img-flags margine-dx-mezzo ico-cat ${icoSport}`}></div>
                                    <div className={`img-fluid img-flags margine-dx-mezzo ico-cat ${icoCategory}`}></div>
                                    <span>{tournament.tournamentDesc}</span>
                                </div>
                                <div className={!props.collapse?'collapse show':'collapse'} id={"tournament-collapse-" + tournament.tournamentId}>
                                    <div className="collapse show" id="paese-calcio-1-aa">
                                        <div className="tabellaQuoteIntestazione tabellaQuoteIntestazione-3col-agenda-streaming text_s1 mb-2">
                                            <div className="tabellaQuoteTempo d-flex justify-content-center align-items-center">
                                                <p>{getLabel('prematch_page.torneo.tournament_day_header.time')}</p>
                                            </div>
                                            <div className="tabellaQuoteCampetto">&nbsp;</div>
                                            <div className="tabellaQuoteSquadre d-flex justify-content-center align-items-center"></div>
                                            <div className="tabellaQuoteContenitoreQuotazioni d-flex justify-content-end align-items-center flex-grow-1"></div>
                                            <div className="tabellaQuoteStatistiche"></div>
                                            <div className="tabellaQuoteAltre d-flex justify-content-center align-items-center"></div>
                                        </div>
                                        {Object.values(tournament.matchesById).map(function(match,mIndex){
                                            const pointer = prematchContext.section === 'top-match'?match.str:true
                    
                                            function changeMatch(){
                                                prematchContext.section === 'top-match'?
                                                    toggleStreaming(match)
                                                :
                                                agendaStreamingContext.setCurrentMatch(match)
                                            }
                                            return (!match.strOver && 
                                                <React.Fragment key={match.matchId}>
                                                    <div key={"tournament-match-" + match.matchId} className={`tabellaQuoteNew tabellaQuoteNew-3col text_s1 mb-2 ${pointer?'pointer':''}`} onClick={pointer && changeMatch}>
                                                        <div className="tabellaQuoteTempo d-flex justify-content-center align-items-center">
                                                            <div className="tempo-live text-center">
                                                                <span className="fraz-gioco colore-1 margine-dx-mezzo">{match.date.formatted}</span>
                                                            </div>
                                                        </div>
                                                        <div className="tabellaQuoteCampetto">
                                                            {match.str?
                                                                <Img src="assets/img/sport/svg/live-streaming-play.svg" className="img-fluid" alt="Play streaming" />
                                                            :
                                                            match.strOver?
                                                            <p>{getLabel("live_page.streams_schedule.ended")}</p>
                                                            :
                                                            <p>{getLabel("live_page.streams_schedule.not_started")}</p>
                                                            }
                                                        </div>
                                                        <div className="tabellaQuoteSquadre">
                                                            <div className="d-flex items-center">
                                                                {match.team2 &&
                                                                    <Jersey data={match.jerseys?.[0]} type={'home'} sportRef={match.sportRef} />
                                                                }
                                                                <p className="font-weight-bold m-0 text-right" title={match.team1}>
                                                                    <span>{match.team1}</span>
                                                                </p>
                                                            </div>
                                                            {match.team2 != null &&
                                                                <>
                                                                    <p className="font-weight-bold colore-1 m-0 px-2 tabellaQuoteSquadreSeparatore">vs</p>
                                                                    <div className="d-flex items-center">
                                                                        <Jersey data={match.jerseys?.[1]} type={'away'} sportRef={match.sportRef} />
                                                                        <p className="font-weight-bold m-0 text-left" title={match.team2}>
                                                                            <span>{match.team2}</span>
                                                                        </p>
                                                                    </div>
                                                                </>
                                                            }
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </>
            }
        </>
    );
}

export default AgendaStreamingSport;